import { State } from './types';

const initialState: State = {
	projectId: null,
	byProjectId: {}
};

export default initialState;
